import React from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';
import { updateGuarBeneficiaryStatus } from 'services/guaranty';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';


export type GarantyStatusButtonProps = ButtonProps & {
    guarid: number;
    guarassocid: number;
    status: string;
    refetch: () => void;
    fromextra?: boolean;
};

const GarantyStatusButton: React.FC<GarantyStatusButtonProps> = ({
    size = 'small',
    guarid,
    status,
    refetch,
    fromextra,
    guarassocid,
    ...props
}) => {
    const { getComponentLabel } = useDisplayFrameworkContext();

    let newStatus = '',
        statuslabel = '';
    switch (status) {
        case 'INIT':
            newStatus = 'ACTIVE';
            statuslabel = getComponentLabel('activate');
            break;
        case 'ACTIVE':
            newStatus = 'DISABLED';
            statuslabel = getComponentLabel('disable');
            break;
        case 'DISABLED':
            newStatus = 'TERMINATED';
            statuslabel = getComponentLabel('terminate');
            break;
        case 'TERMINATED':
            newStatus = 'ACTIVE';
            statuslabel = getComponentLabel('activate');
            break;
    }
    return (
        <Popconfirm
            title="Sure to change the status?"
            onConfirm={() => {
                updateGuarBeneficiaryStatus({
                    gassocid: guarassocid,
                    guarid: guarid,
                    status: newStatus,
                }).then((response) => {
                    if (response.code === '200') {
                        notification.success({
                            message: response.message,
                        });
                        refetch();
                    }
                });
            }}
        >
            <Button
                icon={<SwapOutlined twoToneColor="#52c41a" />}
                onClick={() => { }}
                {...props}
                style={fromextra ? { width: '100%', height: 60 } : {
                    width: 100,
                    height: 40,
                    marginLeft: 5,
                    marginRight: 5,
                    marginBottom: 5,
                }}
            >
                {statuslabel}
            </Button>
        </Popconfirm>
    );
};

export default GarantyStatusButton;
